module.exports = __webpack_public_path__ + "static/tim-haskins-lg-c5cadfe93fa764439f0430bb74b356f9.png";